import { Instance, types } from 'mobx-state-tree';

export const ServiceModelModel = types.model('ServiceModelModel', {
  id: types.number,
  name: types.string,
  extProductUuid: types.string,
  status: types.number,
  isOld: types.number,
});

export type ServiceModel = Instance<typeof ServiceModelModel>
